import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { DeleteDedicationAPI } from '../api/mytunes/deletededication/deletededicationapi';
import { DeleteDedicationRequest } from '../api/mytunes/deletededication/deletededicationrequest';
import { DeleteDedicationResponse } from '../api/mytunes/deletededication/deletededicationresponse';
import { DeleteFromShuffleAPI } from '../api/mytunes/deletefromshuffle/deletefromshuffleapi';
import { DeleteFromShuffleRequest } from '../api/mytunes/deletefromshuffle/deletefromshufflerequest';
import { DeleteFromShuffleResponse } from '../api/mytunes/deletefromshuffle/deletefromshuffleresponse';
import { ListTonesAPI } from '../api/mytunes/listtones/listtonesapi';
import { ListTonesRequest } from '../api/mytunes/listtones/listtonesrequest';
import { ListTonesResponse } from '../api/mytunes/listtones/listtonesresponse';
import { TimeBasedSettingForAllCallersAPI } from '../api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersapi';
import { TimeBasedSettingForAllCallersRequest } from '../api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersrequest';
import { TimeBasedSettingForAllCallersResponse } from '../api/mytunes/timebasedsettingforallcallers/timebasedsettingforallcallersresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { DefaultToneRequest } from '../api/defaulttone/defaulttonerequest';
import { DefaultToneResponse} from '../api/defaulttone/defaulttoneresponse';
import { DeleteFromShuffleAPIProcessorImpl } from '../processor/deletefromshuffleapiprocessor';
import { DeleteDedicationAPIProcessorImpl } from '../processor/deletededicationapiprocessor';
import { ListTonesAPIProcessorImpl } from '../processor/listtonesapiprocessor';
import { ListTonesForPlaylistAPIProcessorImpl } from '../processor/listtonesforplaylistapiprocessor';
import { ListTonesForTunesAPIProcessorImpl } from '../processor/listtonesfortunesapiprocessor';
import { TimeBasedSettingForAllCallersAPIProcessorImpl } from '../processor/timebasedsettingforallcallersapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { TimeBasedSettingForCallersGroupAPIProcessorImpl } from '../processor/timebasedsettingforcallersgroupapiprocessor';
import { TimeBasedSettingForCallersGroupRequest } from '../api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgrouprequest';
import { TimeBasedSettingForCallersGroupResponse } from '../api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupresponse';
import { TimeBasedSettingForCallersGroupAPI } from '../api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupapi';
import { TimeBasedSettingForSpecificCallerResponse } from '../api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerresponse';
import { TimeBasedSettingForSpecificCallerRequest } from '../api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerrequest';
import { TimeBasedSettingForSpecificCallerAPI } from '../api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerapi';
import { TimeBasedSettingForSpecificCallerAPIProcessorImpl } from '../processor/timebasedsettingforspecificcallerapiprocessor';
import { ShuffleRequest } from '../api/shuffle/shufflerequest';
import { ShuffleResponse } from '../api/shuffle/shuffleresponse';
import { ShuffleActivationAndDeactivationAPIProcessorImpl } from '../processor/shuffleactivationeactivationapiprocessor';
import { ShuffleActivationAndDeactivationAPI } from '../api/shuffle/shuffleactivationdeactivationapi';
import { DefaultToneAPIProcessorImpl } from '../processor/defaulttoneapiprocessor';
import { DefaultToneAPI } from '../api/defaulttone/defaulttoneapi';
import { ListTonesForCurrentlyPlayingTunesAPIProcessorImpl } from '../processor/listtonesforcurrentlyplayingapiprocessor';

export class MyTunesProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(MyTunesProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getListTonesAPIProcessor():APIProcessor<ListTonesRequest, ListTonesResponse>
    {
        this.logger.log("getListTonesAPIProcessor() invoked");
        return new ListTonesAPIProcessorImpl(this.getContext(), new ListTonesAPI(this.getHttpClient(), this.getContext()));
    }

    getShuffleAPIProcessor():APIProcessor<ShuffleRequest, ShuffleResponse>
    {
        this.logger.log("getShuffleAPIProcessor() invoked");
        return new ShuffleActivationAndDeactivationAPIProcessorImpl(this.getContext(), new ShuffleActivationAndDeactivationAPI(this.getHttpClient(), this.getContext()));

}

getDefaultTuneAPIProcessor():APIProcessor<DefaultToneRequest, DefaultToneResponse>
{
    this.logger.log("getDefaultTuneAPIProcessor() invoked");
    return new DefaultToneAPIProcessorImpl(this.getContext(), new DefaultToneAPI(this.getHttpClient(), this.getContext()));

}
    getListTonesForTunesAPIProcessor():APIProcessor<ListTonesRequest, ListTonesResponse>
    {
        this.logger.log("getListTonesForTunesAPIProcessor() invoked");
        return new ListTonesForTunesAPIProcessorImpl(this.getContext(), new ListTonesAPI(this.getHttpClient(), this.getContext()));
    }

    getListTonesForCurrentlyPlayingTunesAPIProcessor():APIProcessor<ListTonesRequest, ListTonesResponse>
    {
        this.logger.log("getListTonesForTunesAPIProcessor() invoked");
        return new ListTonesForCurrentlyPlayingTunesAPIProcessorImpl(this.getContext(), new ListTonesAPI(this.getHttpClient(), this.getContext()));
    }
    getListTonesForPlaylistAPIProcessor():APIProcessor<ListTonesRequest, ListTonesResponse>
    {
        this.logger.log("getListTonesForPlaylistAPIProcessor() invoked");
        return new ListTonesForPlaylistAPIProcessorImpl(this.getContext(), new ListTonesAPI(this.getHttpClient(), this.getContext()));
    }

    getDeleteFromShuffleAPIProcessor():APIProcessor<DeleteFromShuffleRequest, DeleteFromShuffleResponse>
    {
        this.logger.log("getDeleteFromShuffleAPIProcessor() invoked");
        return new DeleteFromShuffleAPIProcessorImpl(this.getContext(), new DeleteFromShuffleAPI(this.getHttpClient(), this.getContext()));
    }
    getDeleteDedicationAPIProcessor():APIProcessor<DeleteDedicationRequest, DeleteDedicationResponse>
    {
        this.logger.log("getDeleteDedicationAPIProcessor() invoked");
        return new DeleteDedicationAPIProcessorImpl(this.getContext(), new DeleteDedicationAPI(this.getHttpClient(), this.getContext()));
    }
    getTimeBasedSettingForAllCallersAPIProcessor():APIProcessor<TimeBasedSettingForAllCallersRequest, TimeBasedSettingForAllCallersResponse>
    {
        this.logger.log("getTimeBasedSettingForAllCallersAPIProcessor() invoked");
        return new TimeBasedSettingForAllCallersAPIProcessorImpl(this.getContext(), new TimeBasedSettingForAllCallersAPI(this.getHttpClient(), this.getContext()));
    }

    getTimeBasedSettingForCallersGroupAPIProcessor():APIProcessor<TimeBasedSettingForCallersGroupRequest, TimeBasedSettingForCallersGroupResponse>
    {
        this.logger.log("getTimeBasedSettingForCallersGroupAPIProcessor() invoked");
        return new TimeBasedSettingForCallersGroupAPIProcessorImpl(this.getContext(), new TimeBasedSettingForCallersGroupAPI(this.getHttpClient(), this.getContext()));
    }

    getTimeBasedSettingForSpecificCallerAPIProcessor():APIProcessor<TimeBasedSettingForSpecificCallerRequest, TimeBasedSettingForSpecificCallerResponse>
    {
        this.logger.log("getTimeBasedSettingForSpecificCallerAPIProcessor() invoked");
        return new TimeBasedSettingForSpecificCallerAPIProcessorImpl(this.getContext(), new TimeBasedSettingForSpecificCallerAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/mytunesprocessorfactory.tsx